@let _alert = alert();

<div class="message">
  <i class="message__icon" [ngClass]="iconClass()"></i>

  @if (_alert.caption) {
    <p class="message__text" [idealsTranslatedContent]="_alert.caption">
      <a
        *idealsTranslatedWrapper="'iDealsSupportTeam'"
        class="message__link"
        href="#"
        (click)="onShowChat($event)"
      >
        iDealsSupportTeam
      </a>
    </p>
  }

  @if (_alert.htmlCaption) {
    <p class="message--html" [innerHTML]="_alert.htmlCaption | translate: _alert.htmlCaptionParams"></p>
  }

  <ng-container *ngTemplateOutlet="_alert.template"/>
</div>

<button
  [attr.aria-label]="'Close' | translate"
  class="close icons-cross"
  type="button"
  (click)="close()"
  data-ideals="close"
>
</button>
